import Modal from "./Modal";

export default function ConfirmModal({ open, title="Are you sure?", message, onCancel, onConfirm }) {
  return (
    <Modal open={open} title={title} onClose={onCancel}>
      <p className="text-sm text-black/70">{message}</p>
      <div className="mt-4 flex gap-2 justify-end">
        <button className="px-4 h-9 rounded border" onClick={onCancel}>Cancel</button>
        <button className="px-4 h-9 rounded bg-black text-white" onClick={onConfirm}>Delete</button>
      </div>
    </Modal>
  );
}
